/**
 * CE QU'UN DOSSIER EST, ET DANS QUEL ORDRE LE PROPOSER.
 *
 * Rattacher une demande d'acte à une « Analyse d'éligibilité » ou à une
 * « Recherche d'acte » n'a presque jamais de sens : ce qu'on cherche, c'est le
 * dossier de NATIONALITÉ. Les codes viennent de `actes.services` tels quels —
 * relevés sur la base, pas devinés :
 *
 *   cnf · nationalite_par_mariage · nationalite_par_residence ·
 *   action_declaratoire_de_nationalite · contestation_de_refus_de_cnf ·
 *   contentieux_cnf_loi_de_1927 · reintegration ·
 *   contestation_refus_de_reintegration ·
 *   contestation_refus_nationalite_par_mariage · passeport ·
 *   contestation_refus_de_passeport
 *
 * C'est un ORDRE, jamais un filtre : tout reste proposé, et un dossier sans
 * service reste au milieu — on ne le punit pas de ne rien porter.
 */
const FIRST = new Set([
  'cnf', 'nationalite_par_mariage', 'nationalite_par_residence',
  'action_declaratoire_de_nationalite', 'contestation_de_refus_de_cnf',
  'contentieux_cnf_loi_de_1927', 'reintegration',
  'contestation_refus_de_reintegration', 'contestation_refus_nationalite_par_mariage',
  'passeport', 'contestation_refus_de_passeport',
]);
const LAST = new Set([
  'transcription_d_acte_de_mariage', 'transcription_d_acte_de_naissance',
  'recherche_d_acte', 'enregistrement_de_jugement_etranger',
  'casier_judiciaire_francais', 'analyse_eligibilite', 'aes',
]);

/** 0 = nationalité, 1 = on ne sait pas, 2 = à côté. */
export function dossierRank(codes?: string[] | null): number {
  const c = codes ?? [];
  if (c.some((x) => FIRST.has(x))) return 0;
  if (c.length && c.every((x) => LAST.has(x))) return 2;
  return 1;
}

/** Le même ordre, appliqué à une liste, en gardant l'ordre d'origine à égalité. */
export function byDossierRank<T>(list: T[], codesOf: (x: T) => string[] | undefined | null): T[] {
  return list
    .map((x, i) => ({ x, i, r: dossierRank(codesOf(x)) }))
    .sort((a, b) => a.r - b.r || a.i - b.i)
    .map((e) => e.x);
}
